import {theme as base} from '@chakra-ui/react'
import {FontTheme} from '../types/typography.types'

const fonts: FontTheme = {
    fonts: {
        heading: `'BraunLinear', 'Noto Sans', ${base.fonts?.heading}`,
        body: `'BraunLinear', 'Noto Sans', ${base.fonts?.body}`,
        primary: `'BraunLinear', 'Noto Sans', ${base.fonts?.heading}`,
        secondary: `'BraunLinear', 'Noto Sans', ${base.fonts?.body}`,
    },
}

export default fonts
